import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Elena R.',
  location: 'Florida',
  quote: 'Cuando mis amigas vinieron a casa y me preguntaron qué decorador había contratado, no podía creerlo. Mis cortinas se ven exactamente como las de esos hoteles de Beverly Hills que siempre admiré. Nadie sabe que las hice yo misma con tela de $5 el metro.',
  highlight: 'Beverly Hills en mi sala'
}, {
  name: 'Marta S.',
  location: 'Texas',
  quote: 'Gasté años comprando telas caras y el resultado siempre se veía "casero". Con el Método Perfect-Hang aprendí a elegir lonetas baratas que, con el tratamiento correcto, parecen lino importado. Ahorré más de $200 en mi última decoración.',
  highlight: 'Ahorré $200 en telas'
}, {
  name: 'Carmen V.',
  location: 'California',
  quote: 'El truco del dobladillo de 15cm y los pesos de plomo cambió todo. Mis cortinas ahora tienen esa caída de "mármol" que solo ves en las mansiones. Literalmente transformé mi sala por menos de $40 en telas de oferta.',
  highlight: 'Caída perfecta por $40'
}];
export function TestimonialsSection() {
  return <section className="bg-[#FAF7F2] py-12 md:py-18 px-5 md:px-12 border-t border-[#C9A96E]/10" data-id="element-137">
      <div className="max-w-5xl mx-auto" data-id="element-138">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-139">
          <div className="h-px w-16 bg-[#C9A96E] mx-auto mb-4" data-id="element-140" />
          <span className="text-[#C9A96E] uppercase tracking-[0.2em] text-xs font-medium block mb-4" data-id="element-141">
            Resultados Reales
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#1C1C1C]" data-id="element-142">
            Lo que dicen nuestras{' '}
            <span className="italic text-[#C9A96E]" data-id="element-143">clientas</span>
          </h2>
        </motion.div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-144">
          {testimonials.map((t, index) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.12
        }} className="bg-white border border-[#C9A96E]/15 rounded-2xl p-7 flex flex-col gap-5 shadow-sm" data-id="element-145">
              {/* Stars */}
              <div className="flex gap-1" data-id="element-146">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-[#C9A96E] fill-[#C9A96E]" data-id="element-147" />)}
              </div>

              {/* Highlight Badge */}
              <span className="inline-block self-start px-3 py-1 bg-[#C9A96E]/10 text-[#C9A96E] text-xs font-semibold rounded-full tracking-wide" data-id="element-148">
                "{t.highlight}"
              </span>

              {/* Quote */}
              <p className="text-[#1C1C1C]/75 text-sm leading-relaxed flex-1 italic font-serif" data-id="element-149">
                "{t.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-[#C9A96E]/10" data-id="element-150">
                <div className="w-9 h-9 rounded-full bg-[#C9A96E]/20 flex items-center justify-center text-[#C9A96E] font-bold text-sm font-serif" data-id="element-151">
                  {t.name[0]}
                </div>
                <div data-id="element-152">
                  <p className="text-[#1C1C1C] font-semibold text-sm" data-id="element-153">
                    {t.name}
                  </p>
                  <p className="text-[#1C1C1C]/50 text-xs" data-id="element-154">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}